
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]",
      function () {
        return require("private-next-pages/products/[slug].js");
      }
    ]);
  